import { render } from "./MfittBooking2.vue?vue&type=template&id=630182d6"
import script from "./MfittBooking2.vue?vue&type=script&lang=js"
export * from "./MfittBooking2.vue?vue&type=script&lang=js"
script.render = render

export default script